import querystring from 'querystring';
import {
  Link,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from 'react-router-dom';

import enums from '../../helpers/enums';
import formatters from '../../helpers/formatters';
import useApi from '../../helpers/useApi';

import CustomPie from '../../components/CustomPie';
import TableInfo from '../../components/TableInfo';

import Timeline from './Timeline';

const Module = () => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <h1>Single module statistics</h1>
      <div className='navigation-container'>
        <Link to={`${url}`} className='navigation-item'>Overview</Link>
        <Link to={`${url}/timeline`} className='navigation-item'>Timeline</Link>
      </div>
      <Switch>
        <Route exact path={`${path}/`}>
          <Overview />
        </Route>
        <Route path={`${path}/timeline`}>
          <Timeline />
        </Route>
      </Switch>
    </>
  );
};

export default Module;

const Overview = () => {
  const history = useHistory();

  const { isLoading, data } = useApi('analytics/production/module/overview');

  if (isLoading) {
    return (
      <div>Loading....</div>
    );
  }

  const rows = [
    {
      label: 'UUID',
      value: data.module.id,
    },
    {
      label: 'Factory',
      value: enums.factory[data.module.factory_id].label,
    },
    {
      label: 'Total tests',
      value: data.module.count_tests,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ moduleId: data.module.id }),
      }),
    },
    {
      label: 'Passed tests',
      value: data.module.count_tests_passed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ moduleId: data.module.id, testResult: ['passed'] }),
      }),
    },
    {
      label: 'Failed tests',
      value: data.module.count_tests_failed,
      onClick: () => history.push({
        pathname: '/analytics/production/events',
        search: querystring.stringify({ moduleId: data.module.id, testResult: ['failed'] }),
      }),
    },
    {
      label: 'Avg. data sample',
      value: formatters.float(data.module.avg_data_sample),
    },
    {
      label: 'Jig count',
      value: data.module.count_jigs,
    },
  ];

  return (
    <>
      <div className='stats-main-container'>
        <div className='charts-container'>
          <TableInfo rows={rows} />
          <CustomPie
            title='Passed vs. failed tests'
            data={[
              {
                name: 'passed',
                count: data.module.count_tests_passed,
              },
              {
                name: 'failed',
                count: data.module.count_tests_failed,
              },
            ]}
            dataKey='count'
            nameKey='name'
            enumName='testResult'
          />
        </div>
      </div>
    </>
  );
};
